import { IApplicationState } from '../../types/redux';

export const getHasMoreQuestions = (state: IApplicationState): boolean => {
  return state.questions.hasMore;
};
